import { Link } from 'react-router-dom';
import { squadRecords } from '@/mocks/squads';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/feature/Reveal';

const toneStyles: Record<string, string> = {
  现场: 'bg-primary-100 text-primary-800',
  蹲点: 'bg-secondary-100 text-secondary-900',
  细节: 'bg-accent-100 text-accent-900',
  经验: 'bg-background-200 text-foreground-700',
};

export default function SquadPreview() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-950 text-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-10 lg:gap-16">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-6 h-6 flex items-center justify-center text-accent-400">
              <i className="ri-seedling-line"></i>
            </span>
            <span className="text-xs md:text-sm font-medium tracking-[0.18em] text-accent-400 uppercase">
              Field log
            </span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-white leading-snug">
            吃瓜小队的蹲点记录
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-background-300">
            几点到、排了多久、现场秩序如何、散场顺不顺畅——这些不起眼的细节，对真正要去现场的人反而最有用。
          </p>
          <Link
            to="/squad"
            className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-accent-500 text-accent-950 font-medium hover:bg-accent-400 transition-colors whitespace-nowrap"
          >
            <i className="ri-team-line"></i>
            认识吃瓜小队
          </Link>
        </div>

        <Reveal>
          <ol className="relative border-l border-background-800 pl-6 md:pl-8 space-y-7">
            {squadRecords.map((record) => (
              <li key={record.id} className="relative">
                <span className="absolute -left-[31px] md:-left-[39px] top-1.5 w-3.5 h-3.5 rounded-full bg-accent-500 ring-4 ring-background-950"></span>
                <div className="flex items-center gap-3 mb-1.5">
                  <time className="text-xs text-background-400 tracking-wider">{record.time}</time>
                  <span
                    className={`px-2 py-0.5 rounded-full text-[11px] font-medium ${
                      toneStyles[record.tone] ?? 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {record.tone}
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-base md:text-lg text-white">{record.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-background-300">{record.text}</p>
                <p className="mt-2 text-xs text-background-400 flex items-center gap-1.5">
                  <i className="ri-map-pin-line"></i>
                  {record.place}
                </p>
              </li>
            ))}
          </ol>
        </Reveal>
      </div>
    </section>
  );
}